import { render, staticRenderFns } from "./InventoryListDocument.vue?vue&type=template&id=2da89151&"
import script from "./InventoryListDocument.vue?vue&type=script&lang=js&"
export * from "./InventoryListDocument.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListDocument.vue?vue&type=style&index=0&id=2da89151&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports